import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Icon } from '@/ui/icons/icon';
import { Inline } from '@/ui/line/line';
import { SquareLogo } from '@/ui/logo/logo';
import { SmallText } from '@/ui/typography/widgets';

import type { ExampleCompany } from '../explore.state';
import type { Dispatch, SetStateAction } from 'react';

export const ExampleCompanyItem = ({
  company,
  setExampleCompanies,
}: {
  company: ExampleCompany;
  setExampleCompanies: Dispatch<SetStateAction<ExampleCompany[]>>;
}) => {
  return (
    <BadgeContainer alignItems="center" justifyContent="flex-start" gap="4px">
      <SquareLogo name={company.name} logoUrl={company.logoUrl} size="28px" />
      <Text>{company.name}</Text>
      <Icon
        icon="Close"
        onClick={event => {
          event?.stopPropagation();
          setExampleCompanies(addedCompanies =>
            addedCompanies.filter(
              addedCompany => addedCompany.id !== company.id,
            ),
          );
        }}
        color={colors.gray.c13}
        width="10px"
        height="10px"
      />
    </BadgeContainer>
  );
};

const BadgeContainer = styled(Inline)`
  padding: 3px;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray.c2};
  }
`;

const Text = styled(SmallText)`
  ${({ theme }) => `color: ${theme.colors.gray.c12}`};
`;
